import { render, staticRenderFns } from "./AddCustomerToCustomerGroup.vue?vue&type=template&id=7c5a9a45"
import script from "./AddCustomerToCustomerGroup.vue?vue&type=script&lang=js"
export * from "./AddCustomerToCustomerGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports